import { VerificationType } from "@taskfortress/core/src/api/types"
import { useField, useForm } from "@taskfortress/core/src/form"
import { validateEmail } from "@taskfortress/core/src/form/validation"
import { useCallback, useState } from "react"
import { Alert } from "react-native"
import { useAuth } from "../auth"
import { BaseScreen, Button, Text, TextLink } from "../components"
import { AuthForm, AuthLayout } from "../components/auth"
import { TextInput } from "../components/form"

export const ForgotPasswordScreen = ({ navigation }: any) => {
  const [isLoading, setIsLoading] = useState(false)
  const { requestVerification } = useAuth()

  // Form fields
  const emailField = useField({
    name: "email",
    initialValue: "",
    validate: validateEmail,
  })

  // Form management
  const form = useForm({
    fields: [emailField],
  })

  const handleResetPassword = useCallback(async () => {
    if (!form.valid) {
      Alert.alert("Error", "Please enter a valid email address")
      return
    }

    setIsLoading(true)
    try {
      const result = await requestVerification(
        emailField.value!,
        VerificationType.RESET,
      )
      if (result.success && result.verificationToken) {
        navigation.navigate("VerifyCode", {
          email: emailField.value,
          verificationToken: result.verificationToken,
          verificationType: VerificationType.RESET,
        })
      } else {
        Alert.alert(
          "Request Failed",
          "Failed to request verification code. Please try again.",
        )
      }
    } catch (error) {
      console.error("Reset request error:", error)
      Alert.alert(
        "Request Failed",
        "An error occurred while requesting verification code.",
      )
    } finally {
      setIsLoading(false)
    }
  }, [emailField.value, requestVerification, navigation, form.valid])

  return (
    <BaseScreen>
      <AuthLayout>
        <Text className="text-2xl font-bold mb-2 text-center">
          Forgot Password
        </Text>
        <Text className="text-lg text-typography-500 mb-8 text-center">
          Enter your email to receive a verification code
        </Text>

        <AuthForm onSubmit={handleResetPassword}>
          <TextInput
            name="email"
            label="Email"
            placeholder="abc@example.com"
            value={emailField.value}
            handleChange={emailField.handleChange}
            error={emailField.error}
            disabled={isLoading}
            onEnterPress={handleResetPassword}
          />

          <Button
            onPress={handleResetPassword}
            disabled={isLoading || !form.valid}
            isLoading={isLoading}
          >
            Reset Password
          </Button>

          <TextLink
            onPress={() => navigation.navigate("Login")}
            disabled={isLoading}
            className="text-center mx-auto"
          >
            Back to Login
          </TextLink>
        </AuthForm>
      </AuthLayout>
    </BaseScreen>
  )
}
